module.exports = __webpack_public_path__ + "static/media/combo-stacked-icon.9c7f955a.svg";